"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormatterValues = exports.FormatterType = void 0;
var FormatterType;
(function (FormatterType) {
    FormatterType["COMPARE"] = "COMPARE";
    FormatterType["CONDITION"] = "CONDITION";
    FormatterType["IS_DATE"] = "IS_DATE";
    FormatterType["DATE"] = "DATE";
    FormatterType["KEY"] = "KEY";
    FormatterType["REPLACE"] = "REPLACE";
    FormatterType["STRINGIFY"] = "STRINGIFY";
    FormatterType["STATIC"] = "STATIC";
    FormatterType["SPLIT"] = "SPLIT";
})(FormatterType = exports.FormatterType || (exports.FormatterType = {}));
exports.DateFormatterValues = ["YEAR_START", "YEAR_END", "MONTH_START", "MONTH_END", "TODAY"];
